import React from 'react'
import { Button, Modal } from 'react-bootstrap';
import baremoDoctorados from '../../assets/files/Concurso/Doctorados2025/BAREMO DOCTORADOS 2026.pdf'

const ModalCursoGastro = ({ toggleFunction, modalState }) => {
  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title>Concurso Doctorados 2025</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container text-center'>
          {/* <div className='info-group mb-4'>            
            <p className='spaced-md'>Recomendaciones y Estrategias de Prevención</p>
            <p className='fw-bold mb-0'>Cupos Limitados</p>
          </div> */}

          <div className='info-group mt-2'>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Publicación del Baremo y Cronograma: </p>
              <p>02/09/2025</p>
            </div>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Apertura del Concurso: </p>
              <p>16/09/2025</p>
            </div>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Recepción de Credenciales: </p>
              <p>20/10 al 12/12/2025</p>
            </div>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Entrevista: </p>
              <p>19/01 al 30/01/2026</p>
            </div>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Publicación de Resultados: </p>
              <p>02/02 al 06/02/2026</p>
            </div>
            <div className='spaced-md'>
              <p className='fw-semibold mb-1'>Comienzo de Escolaridad: </p>
              <p>02/03/2026</p>
            </div>

            <a 
              href={baremoDoctorados} 
              download={'BAREMO DOCTORADOS 2026'}
              className='link-button btn btn-primary spaced-sm'
            >
              Descargar Baremo
            </a>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalCursoGastro }